import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Dialog,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { getAttendeeAccessPass, getSingleEvent } from "../../../../Redux/Reducers/communityReducer";
import TicketCard from "./TicketCard";
import TicketBookingModal from "./TicketBookingModal";
import { getInterviewers } from "../../../../Redux/Reducers/JobReducer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SideBarAllEventCard = ({ event }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [showTicketCard, setShowTicketCard] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );

  // Format date to "DD Month YYYY" format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
  };

  const handleViewDetails = () => {
    const ticketId = event?.registration?.ticket_id || event.event_code;
    dispatch(getAttendeeAccessPass(ticketId));
    setShowTicketCard(true);
  };

  const handleCloseTicketCard = () => {
    setShowTicketCard(false);
  };

  const handleCardClick = (event) => {
    dispatch(getSingleEvent(event?.id));
    navigate(`/explore/events/${event?.id}`);

  }


  // Use feature_image or fallback
  const imageUrl =
    event?.feature_image || "https://via.placeholder.com/100x100?text=Event";
  const params = { company_name: ProfessionalData?.company_name };

  return (
    <>
      <Card
        sx={{
          display: "flex",
          height: 140,
          mb: 2,
          width: "95%",
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          border: "0.5px solid #d1d5db",
          bgcolor: "background.paper",
          cursor:""
        }}
        onClick={() => handleCardClick(event)}
      >
        {/* Left: Image */}
        <Box
          sx={{
            minWidth: 110,
            width: 110,
            height: 110,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
            borderRadius: "16px",
            overflow: "hidden",
            m: 2,
            flexShrink: 0,
          }}
        >
          <img
            src={imageUrl}
            alt={event.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 16,
            }}
          />
        </Box>

        {/* Dashed line separator */}
        <Box
          sx={{
            position: "relative",
            width: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: 2,
          }}
        >
          <Box
            sx={{
              width: 0,
              height: "100%",
              borderLeft: "2px dashed #d1d5db",
              zIndex: 0,
            }}
          />
        </Box>

        {/* Right: Event Info */}
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            p: 2,
            height: "100%",
          }}
        >
          <Box>
            {/* Title */}
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                fontWeight: 700,
                mb: 1,
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                lineHeight: 1.3,
                fontSize: "1rem",
              }}
            >
              {event.title}
            </Typography>

            {/* Date Only */}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontWeight: 500,
                fontSize: "0.85rem",
              }}
            >
              {formatDate(event.start_time)}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mb: 0.5,
              fontWeight: 500,
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              maxWidth: 180,
            }}
            title={event?.event_location}
          >
            {event?.event_location ||
              (event?.mode === "Online"
                ? "Online Event"
                : "Location not specified")}
          </Typography>

          {/* Register Button - Fixed size */}
          <Typography
            variant="body2"
            sx={{
              color: "#0044C6",
              cursor: "pointer",
              fontWeight: 500,
              fontSize: "0.85rem",
              textDecoration: "none",
              alignSelf: "flex-start",
              mt: "auto",
              "&:hover": {
                color: "#0034A6",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();

              const isFull = event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit;

              if (isFull) return; // Prevent modal from opening


              setBookingModalOpen(true);
              dispatch(getInterviewers(params));
              dispatch(getSingleEvent(event?.id));

            }}
          >
            {event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit
              ? "Seats are full"
              : event?.price_amount > 0
                ? `Register ${event?.price_currency || "$"}${event?.price_amount}`
                : "Register Now"}
          </Typography>


        </CardContent>
      </Card>

      {/* Ticket Card Dialog */}
      <Dialog
        open={showTicketCard}
        onClose={handleCloseTicketCard}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(16px)",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            minHeight: "80vh",
            width: "30%",
            scrollbarWidth: "none",
            position: "relative",
          },
          elevation: 0,
        }}
        sx={{
          "& .MuiDialog-container": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(8px)",
            background: "rgba(0,0,0,0.3)",
          },
        }}
      >
        <Box
          sx={{ position: "relative", width: "100%", p: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseTicketCard}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
            <TicketCard event={event} onClose={handleCloseTicketCard} />
          </Box>
        </Box>
      </Dialog>

      <TicketBookingModal
        open={bookingModalOpen}
        onClose={() => setBookingModalOpen(false)}
        event={event}
      />
    </>
  );
};

export default SideBarAllEventCard;